import { render, staticRenderFns } from "./FeedbackIndex.vue?vue&type=template&id=97f2021a"
import script from "./FeedbackIndex.vue?vue&type=script&lang=js"
export * from "./FeedbackIndex.vue?vue&type=script&lang=js"
import style0 from "./FeedbackIndex.vue?vue&type=style&index=0&id=97f2021a&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports